import { render } from "./vehicle.vue?vue&type=template&id=3fce274e&scoped=true"
const script = {}

import "./vehicle.vue?vue&type=style&index=0&id=3fce274e&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fce274e"]])

export default __exports__